import { useContext } from "react";
import { SortAndFilterContent } from "../../SortAndFilterContent";
import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { getFilterOptionStyle } from "../../utils";
import { useSelector } from "src/redux";
import { useWidgetDndContextData } from "src/context/WidgetDndContext";

function ColorLayout2(props) {
  const { handleCheckboxClick, pageStyle } = useContext(SortAndFilterContent);
  const { filterData, filterName, isType2 } = props;
  const isMobile = isMobileDevice();
  const storeInfo = useSelector((state) => state.storeReducer.store);
  const {
    widgetContextState: { isBuilder, globalStyle },
  } = useWidgetDndContextData();
  const themeColor = isBuilder ? globalStyle?.color?.themeColor : storeInfo?.theme?.colors?.primary_color

  function handleClick() {
    const eventData = {
      target: {
        checked: !filterData?.is_selected,
      }
    }
    handleCheckboxClick?.(eventData, filterName, filterData?.name)
  }

  return (
    <div onClick={handleClick} className={`tw-flex tw-items-center ${isType2 ? 'tw-flex-col tw-gap-[8px] tw-w-[50px] ' : 'tw-gap-[10px] tw-w-[100px]'} tw-cursor-pointer`}>
      <div style={{ border: filterData?.is_selected ? `1px solid ${themeColor}` : '' }}
        className="tw-w-[22px] tw-h-[22px] tw-rounded-[50%] tw-flex tw-justify-center tw-items-center">
        <div style={{ background: filterData?.colour_code }} className="tw-w-[16px] tw-h-[16px] tw-rounded-[50%]"></div>
      </div>
      <div style={{ ...getFilterOptionStyle(pageStyle, isMobile) }} className={`tw-text-[14px] tw-font-normal tw-text-[#111C36B2] ${filterData?.is_selected ? 'tw-font-semibold tw-text-newBlack' : ''}`}>{filterData?.name}</div>
    </div>
  )
}

export default ColorLayout2;